import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Checkbox,
  Grid,
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  Modal,
  InputLabel,
  CircularProgress,
  Pagination,
  Autocomplete,
  FormControlLabel,
  ListItemText,
  TextField,
  Select,
  Collapse,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CustomTextField from "../../../Utils/CustomTextfield";
import {
  deleteBiller,
  deleteEmployee,
  getAllAdmins,
  getAllBillers,
  getAllFacility,
  getEmployee,
  registeration,
  updateBiller,
  updateEmployee,
  updateRegisteration,
} from "../../../api/action";
import { useDispatch, useSelector } from "react-redux";
import CustomSnackbar from "../../../Utils/CustomSnackbar";
import CustomPagination from "../../../Utils/CustomPagination";
import DeleteModal from "../../../Utils/DeleteModal";
import { phoneRegex } from "../../../Utils/Regex";
import * as XLSX from "xlsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { employeeAddSchema, employeeEditSchema } from "../../../Utils/validationSchemas";
import FormTextField from "../../../Utils/FormTextField";
import { sanitizeInput, collapseSpaces, normalizePhone } from "../../../Utils/validationSecurity";

const ROWS_PER_PAGE = 10;

const EmployeeBody = ({ onEdit, onDelete }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [searchFacilityCode, setSearchFacilityCode] = useState("");
  const [searchFacilityName, setSearchFacilityName] = useState("");
  const [searchFacilityType, setSearchFacilityType] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [loading, setLoading] = useState("");
  const [billerId, setBillerID] = useState("");
  const [updated, setUpdated] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const userRole = useSelector((state) => state?.user?.userRole);
  const [facilityID, setFacilityID] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  const [allFacilties, setAllFacilities] = useState([]);
  const [type, setType] = useState("");
  const [editType, setEditType] = useState("");
  const [reporter, setReporter] = useState([]);
  const [editReporter, setEditReporter] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [editStatus, setEditStatus] = useState(false);
  const [userId, setUserId] = useState("");
  const [passwordMessage, setPasswordMessage] = useState("");
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const addForm = useForm({
    resolver: yupResolver(employeeAddSchema),
    mode: "onChange",
    defaultValues: {
      emp_code: "",
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      password: "",
    },
  });

  const editForm = useForm({
    resolver: yupResolver(employeeEditSchema),
    mode: "onChange",
    defaultValues: {
      emp_code: "",
      first_name: "",
      last_name: "",
      phone_number: "",
      password: "",
    },
  });

  const generatePassword = () => {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const special = "@$!%*?&";
    const allChars = uppercase + lowercase + numbers + special;

    let password = "";

    while (!passwordRegex.test(password)) {
      password = "";
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += lowercase[Math.floor(Math.random() * lowercase.length)];
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += special[Math.floor(Math.random() * special.length)];

      for (let i = 4; i < 12; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      password = password
        .split("")
        .sort(() => Math.random() - 0.5)
        .join("");
    }

    return password;
  };

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getAllAdmins(
        payload,
        (data) => {
          setLoading(false);
          const filteredAdmins = data?.data?.Data.filter(
            (admin) =>
              admin.user_role === "Admin Finance" ||
              admin.user_role === "Admin Operations"
          );
          setAdmins(filteredAdmins);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getEmployee(
        payload,
        (data) => {
          setLoading(false);
          setData(data?.data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);

  useEffect(() => {
    setLoading(true);
    const payload = null;
    dispatch(
      getAllFacility(
        payload,
        (data) => {
          setLoading(false);
          setAllFacilities(data?.data?.Data);
        },
        (error) => {
          console.log(error);
          setLoading(false);
        }
      )
    );
  }, [updated]);

  const handleOpenEditModal = (selectedRow) => {
    const reporterNames = selectedRow.reporters.map(
      (reporter) => reporter.reporter_name
    );
    const matchedAdmins = admins.filter((admin) =>
      reporterNames.includes(admin.Full_Name)
    );
    setEditReporter(matchedAdmins);
    setEditModalOpen(true);
    setBillerID(selectedRow.user_id);
    setEditStatus(selectedRow.is_active);
    editForm.reset({
      emp_code: selectedRow.emp_code || "",
      first_name: selectedRow.First_Name || "",
      last_name: selectedRow.Last_Name || "",
      phone_number: selectedRow.Phone_number || "",
      password: "",
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const selectedCodes = data.map((row) => row.emp_code);
      setSelectedRows(selectedCodes);
    } else {
      setSelectedRows([]);
    }
    setSelectAll(event.target.checked);
  };

  const handleCheckboxChange = (facilityCode) => {
    const isSelected = selectedRows.includes(facilityCode);
    let updatedSelectedRows = [];
    if (isSelected) {
      updatedSelectedRows = selectedRows.filter(
        (code) => code !== facilityCode
      );
    } else {
      updatedSelectedRows = [...selectedRows, facilityCode];
    }
    setSelectedRows(updatedSelectedRows);
    setSelectAll(updatedSelectedRows.length === data.length);
  };

  const handleEditClick = (event, selectedFacility) => {
    setAnchorEl(event.currentTarget);
    setSelectedFacility(selectedFacility);
  };

  const handleEditClose = () => {
    setAnchorEl(null);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDelete = () => {
    onDelete(selectedRows);
    setSelectedRows([]);
  };

  const handleAddNew = () => {
    setShowModal(true);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchFacilityCode, searchFacilityName, searchFacilityName]);

  const filteredData = data?.filter((row) => {
    const matchesFacilityCode = row.emp_code
      .toLowerCase()
      .includes(searchFacilityCode.toLowerCase());
    const matchesFacilityName =
      row.First_Name.toLowerCase().includes(searchFacilityName.toLowerCase()) ||
      row.Last_Name.toLowerCase().includes(searchFacilityName.toLowerCase());
    return matchesFacilityCode && matchesFacilityName;
  });

  const handleClearSearch = () => {
    setSearchFacilityCode("");
    setSearchFacilityName("");
    setSearchFacilityType("");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    addForm.reset();
    setPasswordMessage("");
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setPasswordMessage("");
  };

  const onAddSubmit = (formData) => {
    if (reporter.length === 0 || facilityID.length === 0) {
      setSnackbarMessage("Please fill all the fields with valid data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      email: sanitizeInput(formData.email),
      password: formData.password,
      password2: formData.password,
      first_name: sanitizeInput(formData.first_name),
      last_name: sanitizeInput(formData.last_name),
      emp_code: collapseSpaces(sanitizeInput(formData.emp_code)),
      phone_number: normalizePhone(sanitizeInput(formData.phone_number)),
      user_role: type,
      facility_master_ids: facilityID,
      reporter_id: reporter.map((item) => item.user_id),
      is_active: true,
    };

    setLoading(true);
    dispatch(
      registeration(
        payload,
        (data) => {
          console.log(data);
          if (data.status === 200) {
            setLoading(false);
            setSnackbarMessage("Employee added successfully");
            setSnackbarOpen(true);
            setSnackbarSeverity("success");
            setShowModal(false);
            setUpdated((prevState) => !prevState);
            addForm.reset();
            setFacilityList([]);
          } else if (data.status === 226) {
            setLoading(false);
            setSnackbarMessage("Email already exist");
            setSnackbarOpen(true);
            setSnackbarSeverity("error");
          }
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.error ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const onEditSubmit = (formData) => {
    if (editReporter.length === 0) {
      setSnackbarMessage("Please fill all the fields with valid data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const payload = {
      First_Name: sanitizeInput(formData.first_name),
      Last_Name: sanitizeInput(formData.last_name),
      user_id: billerId,
      Phone_number: normalizePhone(sanitizeInput(formData.phone_number)),
      reporter_id: editReporter.map((item) => item.user_id),
      is_active: editStatus,
    };
    if (formData.password) {
      payload.password = formData.password;
    }

    setLoading(true);
    dispatch(
      updateEmployee(
        payload,
        billerId,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Employee updated successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setEditModalOpen(false);
          setUpdated((prevState) => !prevState);
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.detail ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleDeleteBiller = (user_id) => {
    const payload = {
      user_id,
    };

    setLoading(true);
    dispatch(
      deleteEmployee(
        payload,
        (data) => {
          setLoading(false);
          setSnackbarMessage("Employee deleted successfully");
          setSnackbarOpen(true);
          setSnackbarSeverity("success");
          setEditModalOpen(false);
          setUpdated((prevState) => !prevState);
          setOpenDeleteModal(false);
        },
        (error) => {
          console.log(error);
          setLoading(false);
          const errorMessage =
            error.message === "Network Error"
              ? error.message
              : error.response?.data?.detail ||
                "Oops! Looks like we need you to log in again to keep things secure!";
          setSnackbarMessage(errorMessage);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      )
    );
  };

  const handleDeleteModal = (id) => {
    setOpenDeleteModal(true);
    setBillerID(id);
  };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + ROWS_PER_PAGE
  );
  const endIndex = startIndex + ROWS_PER_PAGE;

  const downloadSelectedRows = () => {
    const exportData = filteredData
      .filter((row) => selectedRows.includes(row.emp_code))
      .map((row) => ({
        "Employee Code": row.emp_code,
        "Employee Name": row?.First_Name + " " + row.Last_Name,
        "Email ID": row.email,
        "Phone Number": row.Phone_number,
        "Reporting Manager": row.reporter_name,
        Status: row.is_active === true ? "Active" : "Inactive",
      }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(exportData);
    const columnWidths = [
      { wch: 15 },
      { wch: 20 },
      { wch: 40 },
      { wch: 20 },
      { wch: 50 },
      { wch: 20 },
    ];
    ws["!cols"] = columnWidths;
    XLSX.utils.book_append_sheet(wb, ws, "SelectedRows");
    XLSX.writeFile(wb, "Employees.xlsx");
  };

  const handleEditGeneratePassword = () => {
    const newPassword = generatePassword();
    editForm.setValue('password', newPassword, { shouldValidate: true });
    setPasswordMessage("✅ New password generated");
  };

  const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    addForm.setValue('password', newPassword, { shouldValidate: true });
    setPasswordMessage("✅ New password generated");
  };

  return (
    <Box sx={{ px: 5, py: 2 }}>
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        loading={loading}
        setLoading={setLoading}
        handleDeletefunction={handleDeleteBiller}
        id={billerId}
      />
      <Typography
        variant="h6"
        sx={{ color: "rgba(29, 57, 105, 1)", fontWeight: "bold", mb: 2 }}
      >
        Search Employee
      </Typography>
      <Grid container spacing={5}>
        <Grid item md={3} xs={6}>
          <InputLabel>Employee Code</InputLabel>
          <CustomTextField
            value={searchFacilityCode}
            setValue={setSearchFacilityCode}
          />
        </Grid>
        <Grid item md={3} xs={6}>
          <InputLabel>Employee Name</InputLabel>
          <CustomTextField
            value={searchFacilityName}
            setValue={setSearchFacilityName}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={6}>
          <Box sx={{ display: "flex", justifyContent: "right" }}>
            <Button
              className="buttonPadding"
              variant="contained"
              onClick={handleClearSearch}
              sx={{
                boxShadow: "none !important",
                my: 3,
                mx: 1,
              }}
            >
              Clear
            </Button>
            <Button
              disabled={userRole !== "Admin"}
              className="buttonPadding"
              variant="contained"
              onClick={handleAddNew}
              sx={{
                background: userRole !== "Admin" ? "#d3d3d3" : null,
                boxShadow: "none !important",
                my: 3,
                mx: 1,
              }}
            >
              Add New
            </Button>

            <Button
              className="buttonPadding"
              variant="contained"
              onClick={downloadSelectedRows}
              disabled={selectedRows.length === 0}
              sx={{
                boxShadow: "none !important",
                background: selectedRows.length === 0 ? "#d2d2d2" : null,
                my: 3,
                mx: 1,
              }}
            >
              Download Excel
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Box sx={{}}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <CircularProgress sx={{ color: "rgba(29, 57, 105, 1) !important" }} />
          </Box>
        ) : filteredData.length === 0 ? (
          <Typography
            variant="body2"
            sx={{ textAlign: "center", color: "#555", mt: 15 }}
          >
            No Data Available
          </Typography>
        ) : (
          <>
            <TableContainer component={Paper} className="scrollBar">
              <Table>
                <TableHead
                  sx={{
                    background: "rgba(29, 57, 105, 1)",
                    color: "#fff",
                  }}
                >
                  <TableRow>
                    <TableCell
                      sx={{
                        py: 0,
                        color: "#fff",
                        display: "flex",
                        justifyContent: "left",
                        alignItems: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      <Checkbox
                        checked={selectAll}
                        onChange={handleSelectAll}
                        sx={{ color: "#fff !important" }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                    >
                      Employee Code
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                    >
                      Employee Name
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                    >
                      Email ID
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                    >
                      Phone Number
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                    >
                      Reporting Manager
                    </TableCell>
                    <TableCell
                      sx={{ color: "#fff", py: 0, whiteSpace: "nowrap" }}
                    >
                      Status
                    </TableCell>
                    <TableCell sx={{ color: "#fff", py: 0 }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredData.slice(startIndex, endIndex).map((row) => (
                    <TableRow key={row.emp_code}>
                      <TableCell sx={{ py: 0.3 }}>
                        <Checkbox
                          size="small"
                          checked={selectedRows.includes(row.emp_code)}
                          onChange={() => handleCheckboxChange(row.emp_code)}
                          style={{ color: "rgba(29, 57, 105, 1)" }}
                        />
                      </TableCell>
                      <TableCell
                        className="fs12"
                        sx={{ py: 0.3, whiteSpace: "nowrap" }}
                      >
                        {row?.emp_code}
                      </TableCell>
                      <TableCell
                        className="fs12"
                        sx={{ py: 0.3, whiteSpace: "nowrap" }}
                      >
                        {row?.First_Name + " " + row.Last_Name}
                      </TableCell>
                      <TableCell
                        className="fs12"
                        sx={{ py: 0.3, whiteSpace: "nowrap" }}
                      >
                        {row?.email}
                      </TableCell>
                      <TableCell sx={{ py: 0.3, whiteSpace: "nowrap" }}>
                        {row?.Phone_number}
                      </TableCell>
                      <TableCell sx={{ py: 0.3, whiteSpace: "nowrap" }}>
                        {row?.reporters.map((item, index) => (
                          <Box className="fs12" key={index}>
                            {item?.reporter_name}
                          </Box>
                        ))}
                      </TableCell>
                      <TableCell
                        className="fs12"
                        sx={{
                          py: 0.3,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {row?.is_active === true ? "Active" : "Inactive"}
                      </TableCell>
                      <TableCell sx={{ py: 0.3, whiteSpace: "nowrap" }}>
                        <IconButton
                          disabled={userRole !== "Admin"}
                          color="primary"
                          onClick={() => handleOpenEditModal(row)}
                        >
                          <EditIcon
                            sx={{
                              color:
                                userRole !== "Admin" ? "#d3d3d3" : "rgba(29, 57, 105, 1)",
                              fontSize: "16px",
                            }}
                          />
                        </IconButton>
                        <IconButton
                          disabled={userRole !== "Admin"}
                          color="secondary"
                          onClick={() => handleDeleteModal(row.user_id)}
                        >
                          <DeleteIcon
                            sx={{
                              color:
                                userRole !== "Admin" ? "#d3d3d3" : "rgba(29, 57, 105, 1)",
                              fontSize: "16px",
                            }}
                          />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <CustomPagination
              count={Math.ceil(filteredData.length / ROWS_PER_PAGE)}
              page={currentPage}
              onChange={handleChangePage}
            />
          </>
        )}

        <CustomSnackbar
          open={snackbarOpen}
          handleClose={handleSnackbarClose}
          message={snackbarMessage}
          severity={snackbarSeverity}
        />
      </Box>

      {/* ADD MODAL */}

      <Modal
        open={showModal}
        onClose={handleCloseModal}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box
          className="scrollBar-Y"
          sx={{
            background: "#fff",
            width: "40vw",
            px: 5,
            py: 5,
            mx: "auto",
            borderRadius: "6px",
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              verticalAlign: "middle",
            }}
          >
            <Typography
              className="fs16"
              sx={{ fontWeight: 600, color: "rgba(29, 57, 105, 1)" }}
            >
              Add New Employee
            </Typography>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon
                sx={{
                  color: "#fff",
                  background: "rgba(29, 57, 105, 1)",
                  borderRadius: "25px",
                  height: 20,
                  width: 20,
                  p: 0.5,
                }}
              />
            </IconButton>
          </Box>
          <Box sx={{ my: 2 }} component="form" onSubmit={addForm.handleSubmit(onAddSubmit)}>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <InputLabel>Employee code</InputLabel>
                <FormTextField
                  name="emp_code"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={20}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Employee First Name</InputLabel>
                <FormTextField
                  name="first_name"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={50}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Employee Last Name</InputLabel>
                <FormTextField
                  name="last_name"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={50}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Email</InputLabel>
                <FormTextField
                  name="email"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={254}
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>Phone Number</InputLabel>
                <FormTextField
                  name="phone_number"
                  register={addForm.register}
                  errors={addForm.formState.errors}
                  watch={addForm.watch}
                  maxLength={20}
                />
              </Grid>
              <Grid item md={6} xs={6}>
                <InputLabel>Employee Type</InputLabel>
                <Select
                  fullWidth
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  sx={{ height: "32px", padding: "5px 10px" }}
                >
                  <MenuItem value={"Employee_Office_Work"}>Office</MenuItem>
                  <MenuItem value={"Employee_Admin_Work"}>
                    Administration
                  </MenuItem>
                  <MenuItem value={"Consultant"}>Consultant</MenuItem>
                </Select>
              </Grid>
              <Grid item md={12}>
                <InputLabel>Password</InputLabel>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <FormTextField
                      name="password"
                      register={addForm.register}
                      errors={addForm.formState.errors}
                      watch={addForm.watch}
                      maxLength={128}
                      type="password"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={handleGeneratePassword}
                      type="button"
                      sx={{
                        whiteSpace: "nowrap",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <Typography variant="caption">
                        Generate Password
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
                <Collapse in={Boolean(passwordMessage)}>
                  <Typography variant="caption" sx={{ color: "green" }}>
                    {passwordMessage}
                  </Typography>
                </Collapse>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ display: "block", mt: 0.5 }}
                >
                  Password must be at least 8 characters long, and include one
                  uppercase letter, one lowercase letter, one number, and one
                  special character (@$!%*?&).
                </Typography>
              </Grid>

              <Grid item md={12} xs={6}>
                <InputLabel id="facility-name-label">
                  Reporting Manager
                </InputLabel>
                <Autocomplete
                  className="scrollBar"
                  fullWidth
                  multiple
                  value={reporter}
                  onChange={(event, newValue) => {
                    setReporter(newValue);
                  }}
                  clearIcon={null}
                  options={admins}
                  getOptionLabel={(option) => option.Full_Name}
                  getOptionSelected={(option, value) =>
                    option.Full_Name === value.Full_Name
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.Full_Name === value.Full_Name
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ "& input": { height: "0px", fontSize: "14px" } }}
                    />
                  )}
                />
              </Grid>

              <Grid item md={12}>
                <InputLabel>Facilty</InputLabel>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  fullWidth
                  value={facilityList}
                  onChange={(event, newValue) => {
                    setFacilityList(newValue);
                    setFacilityID(newValue.map((option) => option.id));
                  }}
                  options={allFacilties}
                  getOptionLabel={(option) => `${option.facility_name}`}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <FormControlLabel
                        control={<Checkbox checked={selected} />}
                        label={<ListItemText primary={option.facility_name} />}
                      />
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ "& input": { height: "0px", padding: "5px 10px" } }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              type="submit"
              sx={{
                background: "rgba(29, 57, 105, 1) !important",
                boxShadow: "none !important",
                display: "block",
                mt: 3,
                ml: "auto",
              }}
            >
              {loading ? (
                <CircularProgress size={18} sx={{ color: "#fff" }} />
              ) : (
                "Add"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* EDIT MODAL */}

      <Modal
        open={editModalOpen}
        onClose={handleCloseEditModal}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            background: "#fff",
            width: "40vw",
            px: 5,
            py: 5,
            mx: "auto",
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              verticalAlign: "middle",
            }}
          >
            <Typography
              className="fs16"
              sx={{ fontWeight: 600, color: "rgba(29, 57, 105, 1)" }}
            >
              Edit Employee Detail
            </Typography>
            <IconButton onClick={handleCloseEditModal}>
              <CloseIcon
                sx={{
                  color: "#fff",
                  background: "rgba(29, 57, 105, 1)",
                  borderRadius: "25px",
                  height: 20,
                  width: 20,
                  p: 0.5,
                }}
              />
            </IconButton>
          </Box>
          <Box sx={{ my: 2 }} component="form" onSubmit={editForm.handleSubmit(onEditSubmit)}>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <InputLabel>Employee code</InputLabel>
                <FormTextField
                  name="emp_code"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={20}
                  disabled
                />
              </Grid>
              <Grid item md={6}>
                <InputLabel>First Name</InputLabel>
                <FormTextField
                  name="first_name"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={50}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Last Name</InputLabel>
                <FormTextField
                  name="last_name"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={50}
                />
              </Grid>

              <Grid item md={6}>
                <InputLabel>Phone Number</InputLabel>
                <FormTextField
                  name="phone_number"
                  register={editForm.register}
                  errors={editForm.formState.errors}
                  watch={editForm.watch}
                  maxLength={20}
                />
              </Grid>

              <Grid item md={6} xs={6}>
                <InputLabel>Status</InputLabel>
                <Select
                  fullWidth
                  value={editStatus}
                  onChange={(e) => setEditStatus(e.target.value)}
                  sx={{ height: "32px", padding: "5px 5px", fontSize: "12px" }}
                >
                  <MenuItem value={true}>Active</MenuItem>
                  <MenuItem value={false}>Inactive</MenuItem>
                </Select>
              </Grid>

              <Grid item md={12} xs={6}>
                <InputLabel>Reporting Manager</InputLabel>
                <Autocomplete
                  className="scrollBar"
                  fullWidth
                  multiple
                  value={editReporter}
                  onChange={(event, newValue) => {
                    setEditReporter(newValue);
                  }}
                  clearIcon={null}
                  options={admins}
                  getOptionLabel={(option) => option.Full_Name}
                  getOptionSelected={(option, value) =>
                    option.Full_Name === value.Full_Name
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.Full_Name === value.Full_Name
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{ "& input": { height: "0px", fontSize: "14px" } }}
                    />
                  )}
                />
              </Grid>

              <Grid item md={12}>
                <InputLabel>Password</InputLabel>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <FormTextField
                      name="password"
                      register={editForm.register}
                      errors={editForm.formState.errors}
                      watch={editForm.watch}
                      maxLength={128}
                      type="password"
                    />
                  </Grid>

                  <Grid item xs={4}>
                    <Button
                      onClick={handleEditGeneratePassword}
                      type="button"
                    >
                      <Typography variant="caption">
                        Generate Password
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>

                <Collapse in={Boolean(passwordMessage)}>
                  <Typography variant="caption" sx={{ color: "green" }}>
                    {passwordMessage}
                  </Typography>
                </Collapse>

                <Typography
                  variant="caption"
                  color="textSecondary"
                  sx={{ display: "block", mt: 0.5 }}
                >
                  Password must be at least 8 characters long, and include one
                  uppercase letter, one lowercase letter, one number, and one
                  special character (@$!%*?&).
                </Typography>
              </Grid>
            </Grid>
            <Button
              variant="contained"
              type="submit"
              sx={{
                boxShadow: "none !important",
                display: "block",
                mt: 3,
                ml: "auto",
              }}
            >
              {loading ? (
                <CircularProgress size={18} sx={{ color: "#fff" }} />
              ) : (
                "Update"
              )}
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default EmployeeBody;
